import type { ContractCategory, FlexoesCategoria, GeneroGramatical } from '../types';

const ACAO_POR_CATEGORIA: Record<ContractCategory, string> = {
  NOTIFICACAO: 'criar novas notificações',
  NEGOCIACAO: 'criar novas negociações',
  // Sem contrato a Arbitragem ainda cria, com custa avulsa: o que o fim do teste tira é a
  // criação dentro do convênio (A-23).
  ARBITRAGEM: 'abrir novos processos arbitrais sem custa avulsa',
  MEDIACAO: 'abrir novas mediações',
};

const UNIDADE_POR_CATEGORIA: Record<ContractCategory, string> = {
  NOTIFICACAO: 'notificações',
  NEGOCIACAO: 'negociações',
  ARBITRAGEM: 'processos arbitrais',
  MEDIACAO: 'mediações',
};

const NOME_POR_CATEGORIA: Record<ContractCategory, string> = {
  NOTIFICACAO: 'Notificação',
  NEGOCIACAO: 'Negociação',
  ARBITRAGEM: 'Arbitragem',
  MEDIACAO: 'Mediação',
};

const GENERO_POR_CATEGORIA: Record<ContractCategory, GeneroGramatical> = {
  NOTIFICACAO: 'FEMININO',
  NEGOCIACAO: 'FEMININO',
  ARBITRAGEM: 'MASCULINO',
  MEDIACAO: 'FEMININO',
};

const FLEXOES_POR_GENERO: Record<GeneroGramatical, FlexoesCategoria> = {
  FEMININO: { artigo: 'as', possessivo: 'suas', novos: 'novas', proximos: 'próximas' },
  MASCULINO: { artigo: 'os', possessivo: 'seus', novos: 'novos', proximos: 'próximos' },
};

export function acaoBloqueadaDaCategoria(categoria: ContractCategory): string {
  return ACAO_POR_CATEGORIA[categoria];
}

export function unidadeDaCategoria(categoria: ContractCategory): string {
  return UNIDADE_POR_CATEGORIA[categoria];
}

export function nomeDaCategoria(categoria: ContractCategory): string {
  return NOME_POR_CATEGORIA[categoria];
}

export function flexoesDaCategoria(categoria: ContractCategory): FlexoesCategoria {
  return FLEXOES_POR_GENERO[GENERO_POR_CATEGORIA[categoria]];
}
